import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import * as status from '../../../../common/httpStatusCodes';

class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.handleAllowClick = this.handleAllowClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  handleAllowClick() {
    const {unconfirmedOrder} = this.props;
    this.props.closeDealerSpecialOrderConfirmation();
    this.props.checkDealerSpecialOrderElement({...unconfirmedOrder, 'allowOrder': true}, true);
  }

  handleCancelClick() {
    this.props.closeDealerSpecialOrderConfirmation();
  }
  
  renderOkButton() {
    const {errorCode} = this.props;

    if (errorCode !== status.HTTP_406_NOT_ACCEPTABLE) {
      return null;
    }

    return (
      <Button primary onClick={this.handleAllowClick}>PERMITIR</Button>
    );
  }

  render() {
    const {needConfirmation, errorMessage} = this.props;

    return (
      <Modal
        open={needConfirmation}
        trigger={<div />}
      >
        <Modal.Content>{errorMessage}</Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={this.handleCancelClick}>CANCELAR</Button>
          {this.renderOkButton()}
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'needConfirmation': state.dealerSpecialOrders.needConfirmation,
    'errorMessage': state.dealerSpecialOrders.errorMessage,
    'errorCode': state.dealerSpecialOrders.errorCode,
    'unconfirmedOrder': state.dealerSpecialOrders.unconfirmedOrder,
  };
};

const {
  checkDealerSpecialOrderElement,
  closeDealerSpecialOrderConfirmation,
} = Actions;

export default connect(mapStateToProps, {
  checkDealerSpecialOrderElement,
  closeDealerSpecialOrderConfirmation,
})(ConfirmModal);
